const GET_ITEM = 'app/items/GET_ITEM';
const SET_ITEM = 'app/items/SET_ITEM';
const GET_ITEMS = 'app/items/GET_ITEMS';
const SET_ITEMS = 'app/items/SET_ITEMS';
const SET_ITEM_PACKAGE = '';
const SET_SEARCH_SUMMARY = 'app/items/SET_SEARCH_SUMMARY';

export { GET_ITEM, SET_ITEM, GET_ITEMS, SET_ITEMS, SET_ITEM_PACKAGE, SET_SEARCH_SUMMARY };
